var _ellipse, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDeleteState = function SvgDeleteState(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 116,
    viewBox: "0 0 520 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 260,
    cy: 58,
    rx: 42,
    ry: 42,
    fill: "#FBF4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M245.565 74.7235C245.565 77.3936 247.749 79.5783 250.419 79.5783H269.839C272.509 79.5783 274.694 77.3936 274.694 74.7235V50.4493C274.694 47.7791 272.509 45.5944 269.839 45.5944H250.419C247.749 45.5944 245.565 47.7791 245.565 50.4493V74.7235ZM274.694 38.3122H268.625L266.902 36.5887C266.465 36.1518 265.833 35.8848 265.202 35.8848H255.056C254.425 35.8848 253.793 36.1518 253.357 36.5887L251.633 38.3122H245.565C244.229 38.3122 243.137 39.4045 243.137 40.7396C243.137 42.0747 244.229 43.167 245.565 43.167H274.694C276.029 43.167 277.121 42.0747 277.121 40.7396C277.121 39.4045 276.029 38.3122 274.694 38.3122Z",
    fill: "#FB355D"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDeleteState);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "delete-state.89e5d6f9eff1c9f0aae24fa348ca8d55.svg";